// extracted by mini-css-extract-plugin
export var button = "_eo-0";
export var donut = "_eo-1";
export var donutFill = "_eo-3";
export var donutTrack = "_eo-2";